import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initAuthErrorHandler } from '../lib/authErrorHandler';

/**
 * AppInitializer Component
 *
 * This component initializes global services that need access to React Router's navigate.
 * It should be rendered inside the Router but outside the AuthProvider.
 */
export const AppInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize the auth error handler with the navigate function
    initAuthErrorHandler(navigate);
  }, [navigate]);

  return <>{children}</>;
};

/**
 * AuthErrorHandlerInitializer Component
 *
 * This component is a placeholder for future initialization of auth error handling
 * with the AuthContext. Currently, the error handler is initialized in AppInitializer.
 *
 * This component is rendered inside the AuthProvider to ensure it has access to
 * auth context if needed in the future.
 */
export const AuthErrorHandlerInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // No-op for now - the error handler is initialized in AppInitializer
  // This component exists to maintain the component structure in case we need
  // to add AuthContext-specific initialization in the future
  return <>{children}</>;
};

export default AppInitializer;
